import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { NotificationsServices } from '../../services/notificationsServices';

/**
 * Component que muestra las notificaciones push
 *
 */

@Component({
  selector: 'notifications',
  templateUrl: 'notifications.html',
})
export class NotificationsPage {
  @Input() lang;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public notificationsServices: NotificationsServices) {

  }

  cleanAllNotifications(){
    this.notificationsServices.cleanAllNotifications();
  }

  openCloseNotifications() {
    this.notificationsServices.openCloseNotificationsModal();
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/notifications/notifications.ts